import { render, staticRenderFns } from "./FollowIntentSubEditor.vue?vue&type=template&id=468d3dba"
import script from "./FollowIntentSubEditor.vue?vue&type=script&lang=js"
export * from "./FollowIntentSubEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports